import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Agent.css'; 
import React, { useState, useEffect, useContext } from 'react'; 
import { LandingContext } from '../Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';

const features = [
    { title: 'No Registration Fees', icon: 'ri-money-dollar-circle-line', text: 'Get started and access our entire inventory without any upfront costs.' },
    { title: 'Easy & Clear Navigation', icon: 'ri-compass-3-line', text: 'Our B2B portal is designed to be intuitive, making bookings fast and simple.' },
    { title: 'Global Inventory', icon: 'ri-global-line', text: 'Access over 1 million hotels, 130+ airlines, and thousands of attractions worldwide.' },
    { title: 'Lowest Markups', icon: 'ri-price-tag-3-line', text: 'Benefit from comparative pricing and the lowest B2B markups in the industry.' },
    { title: 'Personalized Vouchers', icon: 'ri-ticket-line', text: 'Issue travel vouchers with your own agency logo for a professional touch.' },
    { title: '24/7 Support', icon: 'ri-customer-service-2-line', text: 'Our experts are committed to providing high-quality service and support around the clock.' }
];

const Agents = () => {
    
  const landingData = useContext(LandingContext);
          const pageStyles = {
              '--theme-primary-color': landingData?.themeColor1 || DefaultData?.THEMECOLOR1,
              '--theme-secondary-color': landingData?.themeColor2 || DefaultData?.THEMECOLOR2
          };
    
    // Style for the hero button to use themeColor1
    const heroButtonStyle = {
        backgroundColor: landingData?.themeColor1 || DefaultData?.THEMECOLOR1,
        borderColor: landingData?.themeColor1 || DefaultData?.THEMECOLOR2,
        color: '#ffffff'
    };

    return (
        // UPDATED: Apply the dynamic styles to the main container
        <div className="main-content" style={pageStyles}>
            <div className="agents-hero-section">
                <Container className="text-center">
                    <h1 className="hero-title">Partner with {DefaultData?.DEFAULTBRANDNAME}</h1>
                    <p className="hero-subtitle">The one-stop B2B solution for your travel business.</p>
                    <Button as={Link} to="/agentregister" size="lg" className="mt-4 fw-bold hero-button" style={heroButtonStyle}>
                        Become an Agent Today
                    </Button>
                </Container>
            </div>

            <div className="page-content">
                <Container>
                    <section className="why-partner-section">
                        <h2 className="section-title text-center">Why We Are Different</h2>
                        <Row className="justify-content-center">
                            <Col lg={8} className="text-center">
                                <p className="lead-text">
                                    When you book with {DefaultData?.DEFAULTBRANDNAME}, your travel arrangements are managed by a professional team of experts with a wealth of specialized knowledge. Becoming a partner enables you to enter our world of limitless services.
                                </p>
                            </Col>
                        </Row>
                    </section>

                    <section>
                        <h2 className="section-title text-center">Our Features for Agents</h2>
                        <Row className="g-4">
                            {features.map(feature => (
                                <Col lg={4} md={6} key={feature.title}>
                                    <div className="feature-card">
                                        <div className="feature-icon">
                                            <i className={feature.icon}></i>
                                        </div>
                                        <h5>{feature.title}</h5>
                                        <p>{feature.text}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </section>
                </Container>
            </div>
        </div>
    );
};

export default Agents;